import { ConsultantType, QuickFilter } from '@/components/filter/FilterModel';
import { CoachRole } from '@/contracts/EmployeeContract';

/**
 * Centralized tag options configuration for search and filters
 * This file contains all available options for tags that appear in:
 * - TopSearchBar (search tags)
 * - AllFiltersModal (filter options)
 */

export interface TagOption {
  label: string;
  value: string;
}

export class TagOptions {
  /**
   * Get consultant type options (Technical, Not Technical)
   */
  public static getConsultantTypeOptions(): TagOption[] {
    return [
      {
        label: "Technical",
        value: ConsultantType.Technical
      },
      {
        label: "Not Technical",
        value: ConsultantType.NonTechnical
      }
    ];
  }

  /**
   * Get people coaches options (Engagement Manager, LT Coach, Firestaerter)
   */
  public static getPeopleCoachesOptions(): TagOption[] {
    return [
      {
        label: "Engagement Manager",
        value: CoachRole.EngagementManager
      },
      {
        label: "LT Coach",
        value: CoachRole.LTCoach
      },
      {
        label: "Firestaerter",
        value: CoachRole.Firestaerter
      }
    ];
  }

  /**
   * Get quick filters options (New Hires, etc.)
   */
  public static getQuickFiltersOptions(): TagOption[] {
    return [
      {
        label: "New Hires (Last 3 months)",
        value: QuickFilter.NewHires
      }
    ];
  }
}





